import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";  
import ItemCard from "../ItemCard"; 
import estilos from "./ListagemItens.module.css";  

function ListagemItens(props) {
  const [termoPesquisa, setTermoPesquisa] = useState("");  // Estado para armazenar o termo de pesquisa
  const navigate = useNavigate();  // Hook para redirecionar o usuário para diferentes rotas

  // Função que lida com a pesquisa
  const pesquisar = () => {
    const nomePesquisado = termoPesquisa.trim().toLowerCase();  // Remove espaços e transforma o termo de pesquisa em minúsculas

    if (nomePesquisado === "") {
      return;  // Se o campo de pesquisa estiver vazio, a função retorna sem realizar nenhuma ação
    }

    // Busca no array de dados um item cujo nome seja exatamente igual ao termo de pesquisa
    const itemEncontrado = props.dados.find(
      (elemento) =>
        elemento.name && 
        elemento.name.toLowerCase() === nomePesquisado
    );

    if (itemEncontrado) {
      navigate(`/personagem/${itemEncontrado.id}`);  // Se o item for encontrado, redireciona para a página do personagem com o ID correspondente
    } else {
      navigate('/naoEncontrada');  // Se o item não for encontrado, redireciona para a página "Não Encontrada"
    }
  };

  return (
    <div className={estilos.container}>  
      <input className={estilos.inputPesquisa}
        type="text"  
        placeholder="Digite um nome" 
        value={termoPesquisa}  // Valor atual do campo de pesquisa (controlado pelo estado)
        onChange={(e) => setTermoPesquisa(e.target.value)}  // Atualiza o estado quando o usuário digita no campo
        onKeyPress={(e) => e.key === 'Enter' && pesquisar()}  // Se o usuário pressionar "Enter", executa a pesquisa
      />

      <div className={estilos.personagens}> 
        {props.dados.map((elemento) => (
          <ItemCard key={elemento.id} dados={elemento} /> 
        ))}
      </div>
    </div>
  );
}

export default ListagemItens;
